import React, { useEffect, useState } from "react";
import DetailPageDiscussComponent from "../DetailPageDiscuss/DetailPageDiscussComponent";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import {
  SessionKeys,
  applyTheme,
  clickStreamUser,
} from "../../../../utils/AppUtils";
import CONFIG from "../../../../utils/config";
import $ from "jquery";
import {
  getBrandDetails,
  getBrandTheme,
  setUserRole,
  userDetailBroker,
} from "../../../../redux/user/actions";
import { loginBrokerResponse } from "../../../../redux/auth/actions";
import Loader from "../../../Loader/Loader";

function DetailLearnDiscussMobilePage() {
  const dispatch = useDispatch();

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const token = params.get("token");
  const key = params.get("key");
  const username = params.get("username");
  const email = params.get("email");
  const source = params.get("source");
  const user_id = params.get("user_id");
  const color_1 = params.get("color_1");
  const color_2 = params.get("color_2");
  const role = params.get("role");
  const apply_theme = params.get("apply_theme");

  const id = params.get("id");
  const code = params.get("code");
  const type = params.get("type");

  const brandThemeRes = useSelector((state) => state.user.brandThemeRes);
  const userBranding = useSelector((state) => state.user.userBranding);
  const [isValidKey, setIsValidKey] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const auth = useSelector((state) => state.auth);

  useEffect(() => {
    console.log("Branding Data", userBranding);
    if (!_.isEmpty(userBranding)) {
      const branding = userBranding.payload.payload;
      if (!_.isEmpty(branding)) {
        applyTheme(branding);
      }
    }
  }, [userBranding]);

  useEffect(() => {
    console.log("token", token);
    if (key === CONFIG.KEY.MOBILE_ACCESS_KEY) {
      setIsLoading(false);
      localStorage.clear();
      // console.log('color', color_1, color_2)
      $("html").css(
        "--color-element-1",
        color_1 ? "#" + color_1 : CONFIG.COLOR_ELEMENT_1
      );
      $("html").css(
        "--color-element-2",
        color_2 ? "#" + color_2 : CONFIG.COLOR_ELEMENT_2
      );
      localStorage.setItem(SessionKeys.API_TOKEN, token);
      localStorage.setItem(SessionKeys.USERNAME, username);
      sessionStorage.setItem(SessionKeys.COMPLETE_TOUR, "1");
      setIsValidKey(true);
      dispatch(setUserRole(role));

      if (apply_theme === "true") {
        dispatch(
          getBrandTheme({
            module: "getBrandTheme",
            postData: {
              token: token,
            },
          })
        );
        dispatch(
          getBrandDetails({
            module: "getUserBrandingData",
            postData: {
              token: token,
            },
          })
        );
      }

      dispatch(
        loginBrokerResponse({
          payload: {
            user: {
              user_id: user_id,
              username: username,
              role: [role],
              email: email,
              branding_primary_color_1: color_1
                ? color_1
                : CONFIG.COLOR_ELEMENT_1,
              branding_primary_color_2: color_2
                ? color_2
                : CONFIG.COLOR_ELEMENT_2,
              apply_theme: apply_theme === "true" ? true : false,
            },
            apiToken: token,
          },
        })
      );

      dispatch(
        userDetailBroker({
          module: "getOrderDetailBroker",
          apiToken: token,
        })
      );
    } else {
      setIsLoading(false);
    }
  }, [token, key, user_id, dispatch]);

  useEffect(() => {
    console.log("brandThemeRes: ", brandThemeRes);
    if (!_.isEmpty(brandThemeRes)) {
      if (brandThemeRes?.status === "success") {
        const branding = brandThemeRes.payload.payload.branding;
        // !_.isEmpty(branding) && applyTheme(branding)
      }
    }
  }, [brandThemeRes]);

  return (
    <>
      {isValidKey ? (
        <>
          <Loader start={isLoading} />
          <DetailPageDiscussComponent
            id={id}
            code={code}
            type={type}
            source={source}
            isMobile={true}
          />
          {/*<FooterNew />*/}
        </>
      ) : (
        <div>{isLoading ? "" : "Invalid Key"}</div>
      )}
    </>
  );
}

export default DetailLearnDiscussMobilePage;
